import { render } from "./PregnancyBanner.vue?vue&type=template&id=784e29d2&scoped=true"
import script from "./PregnancyBanner.vue?vue&type=script&lang=js"
export * from "./PregnancyBanner.vue?vue&type=script&lang=js"

import "./PregnancyBanner.vue?vue&type=style&index=0&id=784e29d2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784e29d2"]])

export default __exports__